import React from "react";
import './styles.css';
import Mobile from "../../../assets/images/mobile-bro.svg";

const AppPlay = () => {
    return (
        <div className="container">
            <div className="row">
                <h1>Aplicativo Gigabyte Play</h1>
                <div className="col-sm-12 col-md-5">
                    <img src={Mobile} alt="foto" />
                </div>
                <div className="col-sm-12 col-md-7">
                    <div>
                        
                    </div>
                </div>
            </div>
        </div>
    );
}
export default AppPlay;